// extracted by mini-css-extract-plugin
export var contents = "style-module--contents--b8be6";
export var footer = "style-module--footer--c946e";
export var header = "style-module--header--48af6";
export var headerLogo = "style-module--headerLogo--6282f";
export var history = "style-module--history--eb1fc";
export var instagram = "style-module--instagram--08dc5";
export var language = "style-module--language--233db";
export var languageSwitch = "style-module--languageSwitch--37d1c";
export var link = "style-module--link--b0d5e";
export var loading = "style-module--loading--4fe92";
export var menu = "style-module--menu--7cd64";
export var menuLogo = "style-module--menuLogo--a24ae";
export var menuModal = "style-module--menuModal--c3b58";
export var menuSwitch = "style-module--menuSwitch--8512f";
export var save = "style-module--save--b7e6f";
export var signup = "style-module--signup--843b4";
export var signupButton = "style-module--signupButton--bd6a2";
export var subLink = "style-module--subLink--d3750";
export var subLinks = "style-module--subLinks--3d496";